import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { roleProm } from "../../model/roles";
import TimeOutSession from "../../utilities/TimeOutSession";
import useRequireToken from "../useRequireToken";

const ProtectedRouteProm = ({ rol, token, children, redirecTo = "/" }) => {
  /* ------------------------------- Comprobar que la sesión esté activa -------------------------------------  */

  useRequireToken(token, redirecTo);

  if (!token) {
    return null;
  }

  /* ------------------------------- Comprobar el rol del usuario -------------------------------------  */

  if (roleProm.value !== rol) {
    return <Navigate to={redirecTo} />;
  }

  /* ------------------------------- redirigir el usuario a su portal -------------------------------------  */

  return (
    <>
      {children ? children : <Outlet />} <TimeOutSession />{" "}
    </>
  );
};

export default ProtectedRouteProm;
